<template>
  <simple-page class="h-100">
    <b-card class="border-primary p-4">
      <h2 class="text-center">
        <span class="text-primary font-weight-bold">
          {{ code }}
        </span>
        {{ $t("errors." + code) }}
      </h2>
    </b-card>
  </simple-page>
</template>
<script>
import FlashMessageSupportMixin from 'vue-template/common/mixins/FlashMessageSupportMixin';

export default {
  mixins: [FlashMessageSupportMixin],
  
  props: {
    code: {
      type: [String, Number],
      required: true
    }
  },

  watch: {
    "$route": {
      immediate: true,
      handler(newValue) {
        console.log('$route', newValue);
      }
    }
  }
};
</script>
